<style lang="scss" scoped>
@import "./loader.scss";
</style>

<template>
  <div :class="`loader-component ${color}`" :style="`border-width: ${thickness}px;`"></div>
</template>

<script>
export default {
  name: "loader-view",
  props: {
    color: { type: String, default: "default" },
    thickness: { type: String, default: "3" },
  },
};
</script>
